/**
 * VIEW FEED CONTENT ENTRY POINT
 *
 * The view feed content page will display all the article snippets in a feed
 *
 * @version 0.1
 */

import React from 'react';
import { Link } from 'react-router';
import reduxStore from './../../reduxStore';
import { FormattedMessage } from 'react-intl';
import api from './../ViewFeedContent/ViewFeedContent.api';
import xhr from './../../utils/xhr';
import headerActions from './../../reusable/Header/Header.actions';
import FeedContentTable from './components/FeedContentTable';
import Spinnable from '../../reusable/Wrappers/SpinnerWrapper/SpinnerWrapper.jsx';
import CopyTextToClipboard from '../../reusable/Form/CopyTextToClipboard';
import FeedArticlesTable from './FeedArticlesTable';
import { hashHistory } from 'react-router';

class ViewFeedContent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            feedName: ''
        };

        this.handleClickArticle = this.handleClickArticle.bind(this);
    }

    componentWillMount() {
        headerActions.updateHeader('viewFeedContent');

        this.props.spinner.showSpinner();
        api.getFeedInfo(this.props.params.feedId)
            .then((result) => {
                this.setState({
                    feedName: result.title,
                    rssLink:  result.rssLink
                });
                this.props.spinner.hideSpinner();
            })
            .catch((error) => {
                this.props.spinner.hideSpinner();
                xhr.handleAllErrors(error);
            });
    }

    buildArticleLink(event, articleId, articleIndex) {
        let location = window.location.href.substr(window.location.href.indexOf('#/') + 2);

        let config = {};
        config.headerKey = "viewFeedContent";
        config.ttl = this.state.feedName;
        config.internalStore = false;
        config.backRoute = location;
        config.url = '/api/feeds/' + this.props.params.feedId + '/articles/paginated';
        config.countUrl = '/api/feeds/' + this.props.params.feedId + "/articles/count";

        hashHistory.push('/view-article/' + articleId + '/' + articleIndex + "?config=" + encodeURIComponent(JSON.stringify(config)));
    }

    handleClickArticle(article, index) {
        this.buildArticleLink(null, article.articleId, index)
    }

    handleDataUpdate(articleList, totalCount, filterCount) {
        reduxStore.dispatch({type: 'ARTICLE_PAGE_TOTAL_COUNT', payload: filterCount});
    }

    render() {
        return (
            <div className="view-feed-content-page">

                <div className="view-feed-content-navigation">

                    <div className="view-feed-content-navigation__backToReview">
                        <span className="backToReview-arrow"></span>
                        <Link to="/feeds">
                            <FormattedMessage id="RSS_View_UIText_viewRssFeedContent.backToManageRssFeeds" />
                        </Link>
                    </div>
                </div>

                <div className="view-feed-content-title">
                    <span className="notranslate">{this.state.feedName}</span>
                    <CopyTextToClipboard inputText={this.state.rssLink}
                                         i18nButtonLabel={'RSS_Feed_UIText_feedListing.copyToClipboard'}
                                         i18nSuccessLabel={'RSS_Feed_UIText_feedListing.copyToClipboard.success'} />
                </div>

                <FeedArticlesTable feedId={this.props.params.feedId}
                                   onClickArticle={this.handleClickArticle}
                                   onDataUpdate={this.handleDataUpdate}/>

                {/*<FeedContentTable feedId={this.props.params.feedId} backRoute="view-feed-articles" feedTitle={this.state.feedName}/>*/}

            </div>
        );

    }
}

export default Spinnable(ViewFeedContent);


// WEBPACK FOOTER //
// ./src/scripts/pages/ViewFeedContent/ViewFeedContent.index.jsx